// extracted by mini-css-extract-plugin
export default {"table-container":"txj8odWWoAwC13z1idCN","table-wrapper":"DraehJb3gjmo1tyZaaen"};